// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_byteowls_capacitor-oauth2_dist_esm_web_js":"a6a03ed290f91726","node_modules_capacitor_preferences_dist_esm_web_js":"ec53c5b33e8dd026"}[chunkId] + ".js";
};